import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';
import { isAttachmentFeatureEnabled } from 'owa-attachment-feature-flags';
import { getBposNavBarData } from 'owa-bpos-store';
import { trace } from 'owa-trace';
var SHAREPOINT_BASE_URLS = [
    'https://microsoft.sharepoint.com',
    'https://microsoft-my.sharepoint.com',
    'https://microsoft.sharepoint-df.com',
    'https://microsoft-my.sharepoint-df.com',
];
export default function isSharePointLink(linkUrl) {
    var bposNavBarData = getBposNavBarData();
    if (!bposNavBarData) {
        trace.info('isSharePointLink:bposNavBarData is null');
        return false;
    }
    if (isSharePointLinkPrefixedWithBaseUrl(linkUrl, bposNavBarData.SPO_MySiteHostUrl)) {
        logUsage(datapoints.AttachmentComposeSPMySiteLinks.datapoint.name);
        return true;
    }
    if (isSharePointLinkPrefixedWithBaseUrl(linkUrl, bposNavBarData.SPO_RootSiteUrl)) {
        return true;
    }
    if (isAttachmentFeatureEnabled('doc-SharePoint-dogfoodUser')) {
        return SHAREPOINT_BASE_URLS.some(function (url) { return isSharePointLinkPrefixedWithBaseUrl(linkUrl, url); });
    }
    return false;
}
function isSharePointLinkPrefixedWithBaseUrl(linkUrl, baseUrl) {
    if (linkUrl.indexOf(baseUrl) === 0) {
        return linkUrl !== baseUrl;
    }
    return false;
}
//# sourceMappingURL=isSharePointLink.js.map